<!-- 轮播图 -->
<template>
  <div
    class="slider-background"
    :style="{
      'background-image': option.back_img ? `url(${option.back_img})` : ''
    }"
  >
    <div
      class="slider-list"
      :style="{
        width: listWidth,
        transition,
        transform
      }"
    >
      <slot> </slot>
    </div>
    <div
      class="coverup"
      :style="{
        'background-image': option.front_img ? `url(${option.front_img})` : ''
      }"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
      @click.capture="coverupJumpLogic"
    ></div>
  </div>
</template>

<script>
// import { Utils } from 'app/utils/Mixins'
// eslint-disable-next-line no-unused-vars
// import { $_width, $_rem } from 'app/utils/global' // eslint-disable-line camelcase

export default {
  components: {},
  props: {
    // eslint-disable-next-line vue/require-default-prop
    activeIndex: Number,
    // eslint-disable-next-line vue/require-default-prop
    tmpIndex: Number,
    // eslint-disable-next-line vue/require-default-prop
    width: Number,
    // eslint-disable-next-line vue/require-default-prop
    size: Number,
    // eslint-disable-next-line vue/require-default-prop
    option: Object,
    // eslint-disable-next-line vue/require-default-prop
    copyListLen: Number
  },
  data() {
    return {
      listWidth: 0,
      transition: 'transform 0ms ease-out',
      transform: 'translate3d(0, 0, 0)',
      timer: 0,
      isMoving: false,
      scaleGap: this.width * (this.option.scale - 1),
      itemWidth: this.option.spaceBetween
        ? this.width + this.option.spaceBetween
        : this.width
    }
  },
  created() {
    this.listWidth =
      (this.size + this.option.appendNum * 2) * this.itemWidth +
      this.scaleGap +
      'px'
  },
  mounted() {
    if (this.size === 1) return
    this.setInitialData()
    this.initLoop()
    this.autoPlay()
    this.goIndex(this.activeIndex)
  },
  methods: {
    onTouchStart(e) {
      if (this.isMoving) return
      if (e.touches.length !== 1) return
      const touch = e.touches[0]
      this.touchStartX = touch.screenX
      this.touchStartY = touch.screenY
      clearTimeout(this.timer)
    },
    onTouchMove(e) {
      if (this.isMoving) return
      if (e.touches.length !== 1) return
      if (this.option.preventDefault) {
        e.preventDefault()
      }
      if (!this.hasMove) {
        this.hasMove = true
      }
      const touch = e.touches[0]
      const x = touch.screenX
      const y = touch.screenY
      const changeX = x - (this.touchStartX == null ? x : this.touchStartX)
      const changeY = y - (this.touchStartY == null ? y : this.touchStartY)

      if (this.option.allowTouchMove) {
        this.currentLeft += changeX
        this.setSliderTouch()
      }
      this.moveLeft = changeX < 0
      this.touchStartX = x
      this.touchStartY = y

      if (
        Math.abs(changeY / Math.sqrt(changeX * changeX + changeY * changeY)) >
        0.866
      ) {
        // 滑动屏幕角度范围：PI/3  -- 2PI/3 Math.sin(Math.PI / 3)
        return true //  不阻止默认行为
      }
      return false
    },
    onTouchEnd(event) {
      if (this.isMoving) return
      if (!this.hasMove) return
      if (this.hasMove) this.hasMove = false
      let i = this.activeIndex
      if (this.currentLeft < this.minLeft) {
        // 手指向左滑动
        i++
      } else if (this.currentLeft > this.maxLeft) {
        // 手指向右滑动
        i--
      } else if (this.currentLeft % this.width !== 0) {
        if (this.moveLeft) {
          // 手指向左滑动
          i++
        } else {
          // 手指向右滑动
          i--
        }
      }
      if (!this.option.loop) {
        if (
          (this.activeIndex === 0 && i === -1) ||
          (this.activeIndex === this.size - 1 && i === this.size)
        )
          return
      }
      this.touchStartX = this.touchStartY = null
      this.goIndex(i)
    },
    setInitialData() {
      this.touchStartX = null
      this.touchStartY = null
      this.timer = null
      this.minLeft = this.option.endPos
      this.maxLeft = this.option.startPos
      this.currentLeft = this.maxLeft // 窗口偏移位置
      this.moveLeft = false
      this.hasMove = false // 是否有滑动还是纯点击
    },
    initLoop() {
      this.minLeft = this.option.endPos
      this.maxLeft = this.option.startPos
      this.currentLeft = this.maxLeft // 窗口向左移动

      // 设置窗口初始偏移位置(为一个slider 的宽度)
      this.setSliderAnimate()
    },
    setSliderTouch() {
      this.transition = 'transform 0ms ease-out'
      this.transform = 'translate3d(' + this.currentLeft + 'px, 0, 0)'
    },
    setSliderAnimate() {
      this.transition = `transform ${this.option.speed}ms ease-out`
      this.transform = 'translate3d(' + this.currentLeft + 'px, 0, 0)'
    },
    autoPlay() {
      if (this.option.auto) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.goIndex(this.activeIndex + 1)
        }, this.option.delay)
      }
    },
    goIndex(i) {
      // 滚动到指定索引
      this.isMoving = true
      if (this.currentLeft === -(this.itemWidth * i) + this.maxLeft) {
        this.complete(i)
        this.isMoving = false
      } else {
        const index = i === -1 ? this.size - 1 : i === this.size ? 0 : i
        this.currentLeft = -(this.itemWidth * i) + this.maxLeft
        this.setSliderAnimate()
        this.onUpdateIndex(index, i)
        setTimeout(() => {
          this.complete(i)
          this.onUpdateIndex(index, index)
          this.isMoving = false
        }, this.option.speed)
      }
    },
    complete(i) {
      // 动画完成回调函数
      if (i === -1) {
        this.currentLeft = this.minLeft
      } else if (i === this.size) {
        this.currentLeft = this.maxLeft
      }
      this.setSliderTouch()
      this.autoPlay()
    },
    jumpLogic(data) {
      this.$traceClick({
        spm: data.spm.img,
        params: data
      })
      // Utils.jumpLogic({
      //   wxlink: data.h5_url,
      //   applink: data.app_url,
      //   spm: data.spm.img
      // })
    },
    onUpdateIndex(index, tmpIndex) {
      this.$emit('updateIndex', {
        index,
        tmpIndex
      })
    },
    coverupJumpLogic() {
      this.$emit('coverupJumpLogic')
    }
  }
}
</script>
<style lang="scss" scoped>
.slider-background {
  background-repeat: no-repeat;

  background-size: 100%;

  background-position: bottom center;
  .slider-list {
    display: flex;

    justify-content: center;
    align-items: center;
  }
  .coverup {
    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: 100%;
  }
}
</style>
